import React, {FC} from 'react';
import Souhait from '../screens/Souhait';
import UiKit from '../screens/UiKit';

const App: FC = () =>
  window.location.pathname === '/ui-kit' ? <UiKit /> : <Souhait />;

export default App;
